
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignComponentsButton',
  components: { DesignContentLayout }
};
